import { FunctionComponent, useEffect, useState } from "react";
import { Table } from "@mantine/core";
import type { UserStakeRecord } from "@/types/network";
import { numberWithCommas } from "@/utils/format";
import dayjs from "dayjs";

const UnStakeList: FunctionComponent<{
  items: UserStakeRecord[];
}> = ({ items }) => {
  return (
    <div className="bg-white rounded-lg py-4 px-6 max-h-[128px] overflow-y-scroll">
      <Table
        fontSize="xs"
        verticalSpacing="xs"
        horizontalSpacing="xs"
        className="un-stake-table"
      >
        <thead>
          <tr>
            <th className="w-[43%]">Amount</th>
            <th>Available on</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td></td>
            <td></td>
          </tr>
          {items
            .sort((a, b) => {
              return a.unLockTime - b.unLockTime;
            })
            .map((item) => {
              const isAvailable = item.unLockTime <= Date.now();

              return (
                <tr key={item.tokenId}>
                  <td>{numberWithCommas(parseFloat(item.stakedAmount))} KAT</td>
                  <td>
                    {isAvailable
                      ? "Available now"
                      : dayjs(item.unLockTime).format("M/D/YYYY [at] hA")}
                  </td>
                </tr>
              );
            })}
        </tbody>
      </Table>
    </div>
  );
};

export default UnStakeList;
